module.exports = __webpack_public_path__ + "img/elementary_sinature.417d0eaa.png";